import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AuthRedirectService, AuthService, GlobalMessageService, 
  GlobalMessageType, RoutingService, SiteContextActions, StateWithClientAuth, 
  TranslationService, UserIdService, WindowRef, I18nModule,OCC_USER_ID_CURRENT,AuthActions } from '@spartacus/core';
import { Observable, from, interval } from 'rxjs';
import { map, shareReplay, tap, withLatestFrom } from 'rxjs/operators';
import { StartupService } from 'src/app/core/services/start-up.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomLoginService } from '../custom-login-form/custom-login.service';
import InventoryManagementService from '../../custom-landing/inventory-unpublished-batch/inventory-management.service';
import { NavigationStart, Router } from '@angular/router';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { LanguageService } from '@spartacus/core';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomPlatformBannerComponent } from '../custom-platform-banner/custom-platform-banner.component';
import { ToastrService } from 'ngx-toastr';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import { User } from 'src/app/interfaces/user';
import { FaceidmodalComponent } from '../custom-login-form/faceidmodal/faceidmodal.component';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgClass } from '@angular/common';
import { FormErrorsComponent } from '@spartacus/storefront';
import { Constants } from '../../../core/constants/url.constants';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DateTimeProvider, OAuthStorage } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';


declare const gigya: any;

@Component({
    selector: 'app-mfa-authentication',
    templateUrl: './mfa-authentication.component.html',
    styleUrls: ['./mfa-authentication.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, FormsModule, ReactiveFormsModule, FormErrorsComponent, NgClass, I18nModule]
})
export class MfaAuthenticationComponent implements OnInit {
  mfaForm: UntypedFormGroup;
  data: any;
  title: any;
  navigationData: string;
  tokenApiData: any;
  userPassword: any;
  showMsg = false;
  error: string;
  isDisabled = false;
  chinaInstance: any;
  unitArray: any;
  menuDisplay: any;
  relUrl: any
  errorMessage:any
  twoFAType:string = '';
  emailtitle: string;
  smstitle: string;
  //timeLeft:number;
  timerId:any;
  countdownTimer: any;
  clearTimeoutFlag:boolean= false;
  display: string;
  timeLeft: number = 59;
  interval:any;
  blockedTimeoutFlag:boolean = false;
  resendOtpData:any;
  countDown:any;
  //countdownObs$!:Observable<any>
  webAuthnAvailable = !!navigator.credentials && !!navigator.credentials.create;
  users: User[];
  useFingerprint = true;
  BASE_URL:string = environment.baseUrl;

  constructor(protected fb: UntypedFormBuilder, private customLoginService: CustomLoginService,  protected auth: AuthService,
              protected globalMessageService: GlobalMessageService, private routingService: RoutingService,
              protected winRef: WindowRef, private startUpService: StartupService, protected store: Store<StateWithClientAuth>,
              protected userIdService: UserIdService,  
              protected authRedirectService: AuthRedirectService,
              private router: Router,
              private customProfileService: CustomProfileService,
              private translation: TranslationService, private inventoryManagementService: InventoryManagementService, public cd: ChangeDetectorRef,
              private languageService: LanguageService,
              private toastService: ToastrService,
              private customproductservice:CustomProductsService,
              public modalService:NgbModal,
              private httpClient: HttpClient,
            private oauthStorage: OAuthStorage,private dateTimeService: DateTimeProvider,) { 
                this.startTimer();
              }

  ngOnInit(): void {
    this.chinaInstanceCheck();
    // this.customProfileService.getBhpUnitList().subscribe(res=>{
    //   if(res){
    //     this.unitArray = res.myB2BUnits;
    //     this.menuDisplay = this.unitArray[0].menuDisplay;
    //   }
    // })
    this.tokenApiData = this.startUpService.startupData;
    this.customLoginService.loginData$.subscribe(data => {
      this.data = data;
      if (!this.data) {
        this.routingService.go({
          cxRoute: 'login',
        });
      }
    });
    this.customLoginService.twoFATypeValue.subscribe(res=>{
      this.twoFAType = res;
    })
    this.customLoginService.userPwd$.subscribe(data => {
      this.userPassword = data;
    });

    this.translation.translate('breadcrumb.otp').subscribe(res => {
      this.emailtitle  = res;
    });
    this.translation.translate('breadcrumb.smsotp').subscribe(res => {
      this.smstitle = res;
    });
    if(this.twoFAType == 'SMS'){
      this.title = this.smstitle;
    }
    else if(this.twoFAType == 'Email'){
      this.title = this.emailtitle;
    }
    else{
      this.title = this.emailtitle;
    }
    this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
      this.error = res;
    });

    this.mfaForm = this.fb.group({
      code: ['', Validators.required],
    });
    
    //  this.timerId = setInterval(this.countdown, 1000);  
    //this.timer(30);
    // this.countdownTimer =setInterval(() => {
    //   this.countDown( this.timeLeft);
    // }, 1000);
    
    
    // const source = interval(1000);
    // this.countdownTimer = source.subscribe(val => this.countDown(this.timeLeft));

 
  }


  timer(minute) {
    // let minute = 1;
    this.blockedTimeoutFlag= true;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

   const prefix = minute < 10 ? "0" : "";

   this.countDown = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      //this.display = this.transform(seconds);
      if (seconds == 0) {
        this.blockedTimeoutFlag= false;
        this.pauseTimer();
      }
    }, 1000);
  }

//   transform(value: number): string {
//     const minutes: number = Math.floor(value / 60);
//     console.log('minutes-->',minutes);
//     return minutes + ':' + (value - minutes * 60);
// }

pauseTimer() {
  clearInterval(this.countDown);
}


  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
       // this.timeLeft = 15;
       this.clearTimeoutFlag = true;
      }
    },1000)
  }

  getConsentUpdateDetails() {
    // let ngmodatoptions : NgbModalOptions = {
    //   backdrop:'static',
    //   keyboard: false,
    //   centered: true,
    //   size:'lg'
    // }
    this.customProfileService.getConsentUpdateDetails(this.data.email, this.data.lastConsentModified_Terms, this.data.currentDocDate_Privacy, this.data.currentDocDate_Terms, this.data.lastConsentModified_Privacy).subscribe(res => {
      console.log('platform', res);
      localStorage.setItem('displayPopuop', res.displayPlatformTCUpdatesPopup)
      // if(res.displayPlatformTCUpdatesPopup == true){
      // const modalRef = this.modalService.open(CustomPlatformBannerComponent, ngmodatoptions); 
      // modalRef.componentInstance.platformBannerList=res;
      // modalRef.componentInstance.UID=this.data.UID;
      // }
    },err=>{
      this.toastService.show(err?err.error?.errors[0]?.message:'Something Went wrong');
    })
  }

  isMobile() {
    var isMobile = (/iphone|ipad|android|ie|blackberry|fennec/).test
      (navigator.userAgent.toLowerCase());
    return isMobile;
  }

  submitOtp(): any {
    const { code } = this.mfaForm.controls;
  
    this.isDisabled = true;
    if (this.data.code === code.value ) {
      this.showMsg = false;
      // if (code.value){
      this.customLoginService.validateCode(this.data.code, this.data.UID, this.data.vToken,this.data.cdcToken)
        .subscribe(data => {
          if (data === 'success') {
            // if(this.isMobile() == true){
            //   const user: User = this.serverMockService.addUser({ email: this.data.email, password: '', credentials: [] });
            //   this.users = this.serverMockService.getUsers();
            //   if (this.webAuthnAvailable && this.useFingerprint) {
            //     this.webAuthnService.webAuthnSignup(user)
            //       .then((credential: PublicKeyCredential) => {
            //         console.log('credentials.create RESPONSE', credential);
            //         const valid = this.serverMockService.registerCredential(user, credential);
            //         this.users = this.serverMockService.getUsers();
            //       }).catch((error) => {
            //         console.log('credentials.create ERROR', error);
            //       });
            //   }
            // }
           
            this.isDisabled = true;
            var email = localStorage.getItem('email');
            this.customProfileService.getBhpData(email).subscribe(res => {
              if (res) {
                this.unitArray = res.myB2BUnits;
                if (this.unitArray.length <= 1) {
                  localStorage.setItem('selectorPref', 'false');
                } else {
                  localStorage.removeItem('selectorPref');
                }
                this.menuDisplay = this.unitArray[0].menuDisplay;
                var companyCode = this.unitArray.filter(data => {
                  return data.uiDefaultAccount == true
                })
                localStorage.setItem('groupCompany', companyCode[0].uid);
                if (companyCode[0]?.menuDisplay) {
                  // if (companyCode[0]?.menuDisplay.defaultLandingPage == 'materials') {
                    this.relUrl = '/';
                    this.languageService.setActive(companyCode[0]?.uiDefaultLanguagePref);
                    this.store.dispatch(new SiteContextActions.SetActiveLanguage(companyCode[0]?.uiDefaultLanguagePref));
                    this.some(this.data.cdcToken);
                  if (this.relUrl) {
                    localStorage.setItem('defaultLandingPage', this.relUrl);
                  }
                }
                else {
                  this.globalMessageService.add('Menu Display is not available for the user id, please contact support team',GlobalMessageType.MSG_TYPE_ERROR);
                  //this.toastService.show('Menu Display is not available for the user id, please contact support team');
                }

              }
              this.getConsentUpdateDetails();
            })
          } else {
            //this.toastService.show(data);
            this.isDisabled = false;
            //this.globalMessageService.add(data, GlobalMessageType.MSG_TYPE_ERROR);
            this.toastService.show("Error occured while submitting the otp. Error" + (data ? data : ''))

          }
        },
          (err: any) => {
            this.errorMessage = err;
            this.toastService.show("Sorry something went wrong, please try again!")
          });
    } else {
      this.isDisabled = false;
      this.showMsg = true;
      this.globalMessageService.add("Invalid Code Provided.", GlobalMessageType.MSG_TYPE_ERROR);

    }

  }

  

  allowNumbersOnly(event): any {
    const k = event.charCode;
    return this.isValidLetter(k);
  }
  isValidLetter(k): any {
    return ((k >= 48 && k <= 57));
  }
  some(cdcToken?: any) {
 let params = new HttpParams({})
        .set('grant_type', 'custom')
        .set('client_id', 'mobile_android')
        .set('username',  this.data.email.toLowerCase())
        .set('cdcToken', cdcToken)
        //.set('password', this.userPassword)
      //params = params.set('code', this.inventoryIdToken);
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
      this.httpClient.post(this.BASE_URL + Constants.ONLYTOKEN, params, { headers }).subscribe((response: any) => {
        if (response) {
        this.storeAccessTokenResponse(response.access_token, response.refresh_token, response.expires_in, response.scope, null)
        this.decodeToken(response.access_token);
        this.userIdService.setUserId(OCC_USER_ID_CURRENT);
        let url = this.relUrl;
        this.store.dispatch(new AuthActions.Login());
          if(url=='/opentenders'){
              this.router.navigate(['/opentenders']).then(()=>{
                location.reload();
              })
            }
            else if(url=='/quotes/myquotes'){
              this.router.navigate(['/quotes/myquotes']).then(()=>{
                location.reload();
              })
            }else{
              this.router.navigate([url]).then(() => {
                if(this.isMobile()==true && this.data.biometricLoginEnabled=='true'){
                   let self = this;
                gigya.accounts.login({loginID:self.data.email.toLowerCase(),password: self.userPassword,
                callback:(responseoflogin)=>{
                gigya.accounts.auth.fido.getCredentials({
                callback: (response) => {
                if(response){
                if(response.credentials && response.credentials.length == 0){
                const ModalRef = self.modalService.open(FaceidmodalComponent, { centered: true, size: 'md' });
                ModalRef.componentInstance.modaltoopen = 'afterOTPSubmit';
                ModalRef.componentInstance.email = self.data.email.toLowerCase();
                ModalRef.componentInstance.password = self.userPassword;
                }}}})}});
                }
              });
            }

            // Remove error messages on successful login
            this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
        }})
  }
  
 
  protected loginUser(): void {
    // Use OAuth Password Grant Flow after successful 2FA validation
    let url = this.relUrl;
    from(
      this.auth.loginWithCredentials(
        this.data.email.toLowerCase(), // backend accepts lowercase emails only
        this.userPassword
      )
    )
      .pipe(
        withLatestFrom(this.auth.isUserLoggedIn()),
        tap(([_, isLoggedIn]) => {
          if (isLoggedIn) {
            // Navigate to appropriate landing page
            if(url=='/opentenders'){
              this.router.navigate(['/opentenders']).then(()=>{
                location.reload();
              })
            }
            else if(url=='/quotes/myquotes'){
              this.router.navigate(['/quotes/myquotes']).then(()=>{
                location.reload();
              })
            }else{
              this.router.navigate([url]).then(() => {
                if(this.isMobile()==true && this.data.biometricLoginEnabled=='true'){
                   let self = this;
                gigya.accounts.login({loginID:self.data.email.toLowerCase(),password: self.userPassword,
                callback:(responseoflogin)=>{
                gigya.accounts.auth.fido.getCredentials({
                callback: (response) => {
                if(response){
                if(response.credentials && response.credentials.length == 0){
                const ModalRef = self.modalService.open(FaceidmodalComponent, { centered: true, size: 'md' });
                ModalRef.componentInstance.modaltoopen = 'afterOTPSubmit';
                ModalRef.componentInstance.email = self.data.email.toLowerCase();
                ModalRef.componentInstance.password = self.userPassword;
                }}}})}});
                }
              });
            }

            // Remove error messages on successful login
            this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
        }),
      )
      .subscribe();
  }
  chinaInstanceCheck() {
    this.customproductservice.privacyPolicyValue.subscribe((resp: any) => {
    
      this.chinaInstance = resp.chinaInstanceCheck;
      this.cd.detectChanges();
    });
  }
  onCancel(): void {
    this.routingService.go({
      cxRoute: 'login',
    });
  }
  resend(twoFAType){
    this.customLoginService.resendOTP(this.data.email.toLowerCase(),twoFAType.toLowerCase()).subscribe(data=>{
      if(data.code){
        //this.resendOtpData = data;
        this.data.code = data.code;
        this.data.vToken = data.vToken;
        twoFAType.toLowerCase() === 'sms'?this.toastService.show("Code sent to your mobile phone."):
        twoFAType.toLowerCase() === 'email'?this.toastService.show("Code sent to your email."):'';       
      }else if(data.error){        
        this.toastService.show("Please try again after some time. error ");       
      }
    }, (err: any) => {    
      this.toastService.show("Please try again after some time. error ");
    });
    this.timer(2);
  }

  storeAccessTokenResponse(accessToken: string, refreshToken: string, expiresIn: number, grantedScopes: string[] | string, customParameters: any) {
    this.oauthStorage.setItem('access_token', accessToken);
    if (grantedScopes && !Array.isArray(grantedScopes)) {
      this.oauthStorage.setItem('granted_scopes', JSON.stringify(grantedScopes.split(' ')));
    }
    else if (grantedScopes && Array.isArray(grantedScopes)) {
      this.oauthStorage.setItem('granted_scopes', JSON.stringify(grantedScopes));
    }
    this.oauthStorage.setItem('access_token_stored_at', '' + this.dateTimeService.now());
    if (expiresIn) {
      const expiresInMilliSeconds = expiresIn * 1000;
      const now = this.dateTimeService.new();
      const expiresAt = now.getTime() + expiresInMilliSeconds;
      this.oauthStorage.setItem('expires_at', '' + expiresAt);
    }
    if (refreshToken) {
      this.oauthStorage.setItem('refresh_token', refreshToken);
    }
    if (customParameters) {
      customParameters.forEach((value: any, key: string) => {
        this.oauthStorage.setItem(key, value);
      });
    }
  }
  private decodeToken(token: string): any {
    try {
      // Split the JWT string (header.payload.signature)
      const parts = token.split('.');
      if (parts.length !== 3) {
        throw new Error('Invalid JWT format');
      }

      // Convert Base64Url to standard Base64
      const base64Url = parts[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      
      // Decode and parse the JSON string
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Failed to decode token:', error);
      return null;
    }
  }

 

}
